import { DotsVerticalIcon, UserIcon } from "@heroicons/react/outline";

const MembersCard = ({
  isAdmin,
  memberEmail,
  memberId,
  memberImage,
  memberName,
}) => {
  return (
    <div className="group flex items-center cursor-pointer space-x-5 py-3 px-3 border border-gray-300 shadow relative rounded-lg">
      <div>
        {memberImage ? (
          <img
            src={memberImage}
            alt="user"
            className="h-10 rounded-full shadow"
          />
        ) : (
          <UserIcon className="h-10 px-2 py-2 rounded-full bg-gray-100 border border-gray-300 shadow" />
        )}
      </div>
      <div>
        <h1 className={`${isAdmin && "truncate"}`}>
          {memberName} {isAdmin && "(Owner)"}
        </h1>
        <p>{memberEmail}</p>
      </div>
      <DotsVerticalIcon
        className={`hidden ${
          !isAdmin && "group-hover:inline-flex"
        } absolute h-7 right-0 top-0 my-2 text-gray-600`}
      />
    </div>
  );
};

export default MembersCard;
